import Chip from "components/common/Chip";
import SuggestSelect from "components/common/input/SuggestSelect";
import React from "react";
import DialogBase from "./DialogBase";

type PROPS = {
  flg: boolean;
  current: string;
  list: { item_cd: string; item_name: string }[];
  data?: { item_cd: string; item_name: string }[];
  close: (result: { item_cd: string; item_name: string }[]) => void;
};

// 関連商品 編集ダイアログ
const RelativeItemDialog: React.FC<PROPS> = (props) => {
  const [items, setItems] = React.useState<
    { item_cd: string; item_name: string }[]
  >([]);
  const [options, setOptions] = React.useState<
    { label: string; value: string }[]
  >([]);

  const onSelect = (id: string) => {
    const target = props.list.find((v) => v.item_cd === id);
    if (target) {
      if (!items.includes(target)) {
        items.push(target);
        setItems([...items]);
      }

      const options = props.list
        .filter((v) => v.item_cd !== props.current)
        .filter(
          (v) => items.find((vv) => vv.item_cd === v.item_cd) === undefined
        )
        .map((v) => {
          return { label: v.item_name, value: v.item_cd };
        });
      setOptions(options);
    }
  };

  const onRemove = (target: { item_cd: string; item_name: string }) => {
    const idx = items.indexOf(target);
    items.splice(idx, 1);
    setItems([...items]);

    const options = props.list
      .filter((v) => v.item_cd !== props.current)
      .filter((v) => items.find((vv) => vv.item_cd === v.item_cd) === undefined)
      .map((v) => {
        return { label: v.item_name, value: v.item_cd };
      });
    setOptions(options);
  };

  React.useEffect(() => {
    const items = props.data ?? [];
    setItems(items);

    const options = (props.list ?? [])
      .filter((v) => v.item_cd !== props.current)
      .filter((v) => items.find((vv) => vv.item_cd === v.item_cd) === undefined)
      .map((v) => {
        return { label: v.item_name, value: v.item_cd };
      });
    setOptions(options);
  }, [props]);

  return (
    <DialogBase
      modalIsOpen={props.flg}
      title="関連商品の設定"
      close={() => {
        props.close(items);
      }}
    >
      <div className="min-w-[40vw] p-4 flex flex-col gap-4">
        <div className="p-2">
          <SuggestSelect
            items={options}
            onSelect={onSelect}
            disabled={items.length >= 10 || options.length === 0}
            maxLength={50}
          />
        </div>
        <div className="border rounded-lg p-2">
          <div className="flex justify-between">
            <div>設定中の商品</div>
            <div>{items.length}/10</div>
          </div>
          <div className="my-4 flex flex-wrap gap-2">
            {items.map((v, i) => {
              return (
                <Chip
                  key={i}
                  text={v.item_name}
                  color="#d1d5db"
                  textColor="#000000"
                  onRemove={() => {
                    onRemove(v);
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </DialogBase>
  );
};

export default RelativeItemDialog;
